import { transformCurrencyAmountDto } from 'data/transformers/currency-amount'

import { WalletBalanceDto, WalletBalanceModel } from '../types/wallet'

export const transformWalletBalanceDto = ({
  available_amount,
  escrow_amount,
}: WalletBalanceDto): WalletBalanceModel => ({
  pendingAmount: transformCurrencyAmountDto(escrow_amount),
  availableAmount: transformCurrencyAmountDto(available_amount),
})
